/* Announcement bar: wisselt rustig tussen de boodschappen (fade + lichte verticale beweging).
   Pauzeert bij hover/focus en als het tabblad niet zichtbaar is; bij prefers-reduced-motion wisselt
   hij zonder beweging. */
(function () {
  if (customElements.get('bb-announce-rotator')) return;

  class BbAnnounceRotator extends HTMLElement {
    connectedCallback() {
      this.slides = Array.from(this.querySelectorAll('.bb-announce__slide'));
      if (this.slides.length < 2) return;
      this.index = 0;
      this.interval = Math.max(3000, parseInt(this.dataset.interval, 10) || 5000);
      this.reduced = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
      if (this.reduced) this.classList.add('is-reduced');
      this.onVisibility = () => (document.hidden ? this.stop() : this.start());
      this.addEventListener('mouseenter', () => this.stop());
      this.addEventListener('mouseleave', () => this.start());
      this.addEventListener('focusin', () => this.stop());
      this.addEventListener('focusout', () => this.start());
      document.addEventListener('visibilitychange', this.onVisibility);
      this.start();
    }

    disconnectedCallback() {
      this.stop();
      document.removeEventListener('visibilitychange', this.onVisibility);
    }

    start() {
      if (this.timer) return;
      this.timer = window.setInterval(() => this.next(), this.interval);
    }

    stop() {
      window.clearInterval(this.timer);
      this.timer = null;
    }

    next() {
      const current = this.slides[this.index];
      this.index = (this.index + 1) % this.slides.length;
      const upcoming = this.slides[this.index];
      current.classList.remove('is-active');
      current.classList.add('is-leaving');
      current.setAttribute('aria-hidden', 'true');
      upcoming.classList.add('is-active');
      upcoming.removeAttribute('aria-hidden');
      window.setTimeout(() => current.classList.remove('is-leaving'), 700);
    }
  }

  customElements.define('bb-announce-rotator', BbAnnounceRotator);
})();
